var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',{staticClass:"text-left"},[_c('VueMarkdown',{attrs:{"source":_vm.source,"plugins":_vm.plugins,"anchorAttributes":_vm.anchorAttributes}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }